(function() {
    'use strict';

    function ModalBloqueioPorHorarioCtrl($scope, $uibModalInstance, operacao, horasAntecendencia) {

      $scope.operacao = operacao;
      $scope.horasAntecendencia = horasAntecendencia;

      $scope.operacoes = {'reagendamento' :
                            {
                              acao : 'reagendar',
                              linkSaibaMais: 'https://mandaenuvemenvio.zendesk.com/hc/pt-br/articles/34308962573332-Reagendamento-de-coleta',
                              estadoAgendamento: 'horário agendado inicialmente'
                            },
                          'cancelamento'  :
                            {
                              acao : 'cancelar',
                              linkSaibaMais: 'https://mandaenuvemenvio.zendesk.com/hc/pt-br/articles/34308962662804-Cancelamento-de-coleta',
                              estadoAgendamento: 'horário agendado'
                            }
                          };

      $scope.cancelar = function() {
        $uibModalInstance.dismiss('cancel');
      }
    };

    angular
      .module('mandaeApp')
      .controller('ModalBloqueioPorHorarioCtrl', ModalBloqueioPorHorarioCtrl);
  })();
